"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
let BlockList = class BlockList extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.keyToSearch = '';
        this.rawBlocks = [
            {
                name: 'Cal-1',
                extension: 12,
                extension_unit: 'acre',
            },
            {
                name: 'Cal-riverside',
                extension: 35,
                extension_unit: 'acre',
            },
            {
                name: 'rhod-3',
                extension: 18,
                extension_unit: 'acre',
            },
            {
                name: 'SanF-Hill',
                extension: 45,
                extension_unit: 'acre',
            },
        ];
        this.checkableBlocks = this.activeProviderAreas.map((b) => {
            return Object.assign(Object.assign({}, b), { label: (`${b.areaName}-${b.extension}-${b.extension_unit}`).toLowerCase() });
        });
        this.showedBlocks = this.checkableBlocks;
        this.checkedBlocks = this.showedBlocks.filter((b) => b.checked);
    }
    isAllSelected() {
        return (this.checkedBlocks.length === this.showedBlocks.filter((b) => b.acreage.value > 0 && b.geometry.length > 1).length && this.checkedBlocks.length > 0);
    }
    toggleAll() {
        if (!this.isAllSelected()) {
            this.checkedBlocks = this.showedBlocks.filter((b) => b.acreage.value > 0 && b.geometry.length > 1);
        }
        else {
            this.checkedBlocks = [];
        }
    }
    isBlockSelected(b) {
        return (this.checkedBlocks.findIndex((cb) => cb.areaName === b) !== -1);
    }
    changeBlockSelected(b) {
        if (this.isBlockSelected(b)) {
            this.checkedBlocks = this.checkedBlocks.filter((cb) => cb.areaName !== b);
        }
        else {
            this.checkedBlocks.push(this.showedBlocks.find((cb) => cb.areaName === b));
        }
    }
    backToList() {
        this.$emit('backToList');
    }
    onchangesearch(text) {
        this.keyToSearch = text.toLowerCase();
        this.showedBlocks = this.checkableBlocks.filter((b) => b.label.includes(this.keyToSearch));
    }
    addSelected() {
        const selected = this.checkedBlocks;
        this.$emit('addSelected', selected);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], BlockList.prototype, "provider", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'area' })
], BlockList.prototype, "importMode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], BlockList.prototype, "activeArea", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], BlockList.prototype, "activeProvider", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], BlockList.prototype, "activeProviderAreas", void 0);
BlockList = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Search: bmk_ui_framework_1.Search,
            TableHeader: bmk_ui_framework_1.TableHeader,
            TableHeaderCell: bmk_ui_framework_1.TableHeaderCell,
            TableBmk: bmk_ui_framework_1.TableBmk,
            TableBody: bmk_ui_framework_1.TableBody,
            TableBodyRow: bmk_ui_framework_1.TableBodyRow,
            TableBodyCell: bmk_ui_framework_1.TableBodyCell,
            CheckBox: bmk_ui_framework_1.CheckBox,
            Button: bmk_ui_framework_1.Button,
            ViewZero: bmk_ui_framework_1.ViewZero,
            MagnifyingGlassIcon: bmk_ui_framework_1.MagnifyingGlassIcon,
            WarningDiamondIcon: bmk_ui_framework_1.WarningDiamondIcon,
            Link: bmk_ui_framework_1.Link,
            Toasts: bmk_ui_framework_1.Toasts,
            Info: lucide_vue_next_1.Info
        },
        emits: ['addSelected', 'backToList']
    })
], BlockList);
exports.default = BlockList;
